export type ContentItem = {
  id: string;
  title: string;
  category: string;
  categoryName: string;
  cover: string;
  duration: string;
  quality: string;
  views: string;
  likes: string;
  hot: number;
  author: string;
  date: string;
  summary: string;
  tags: string[];
  body: string[];
  featured?: boolean;
};

export const contents: ContentItem[] = [
  {
    id: "c-01",
    title: "城市夜空灯光秀刷屏：无人机组画出整条星河",
    category: "hot",
    categoryName: "热点突发",
    cover:
      "https://readdy.ai/api/search-image?query=Aerial%20night%20view%20of%20a%20modern%20city%20with%20a%20glowing%20drone%20light%20show%20shaping%20a%20bright%20galaxy%20above%20the%20skyline%2C%20cinematic%20editorial%20photography%2C%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20soft%20atmospheric%20haze%2C%20high%20detail%2C%20no%20text&width=800&height=520&seq=kanliao-cover-01&orientation=landscape",
    duration: "03:24",
    quality: "4K",
    views: "286.5万",
    likes: "4.2万",
    hot: 9860,
    author: "热料现场",
    date: "2026-09-10",
    summary:
      "千架无人机在城市上空组成星河图案，整段画面几乎零剪辑，夜景细节还原度极高，网友直呼看得停不下来。",
    tags: ["无人机", "灯光秀", "城市夜景"],
    body: [
      "昨晚的城市夜空格外热闹。上千架无人机依次升空，在江面上方缓慢铺开，最终定格成一条横跨天际的星河图案，现场观众的欢呼声几乎盖过了背景音乐。",
      "从画面来看，这段灯光秀几乎没有使用转场剪辑，整个过程一镜到底，暗部细节与高光过渡都很克制，夜景的颗粒感被保留了下来，看起来更像是一段纪录影像而不是特效演示。",
      "有观众表示，自己原本只是路过，结果站在桥边看完了全程。也有人把手机架在三脚架上录制，回看时发现连无人机的闪烁频率都清晰可辨。",
      "如果你错过了现场，这一条内容是目前角度最完整、画质最稳定的版本，建议戴上耳机观看，环境声的层次会比外放明显很多。",
    ],
    featured: true,
  },
  {
    id: "c-02",
    title: "新剧开播首日冲上热搜，主创团队回应观众热议",
    category: "ent",
    categoryName: "娱乐圈",
    cover:
      "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20a%20film%20premiere%20press%20conference%20with%20warm%20spotlights%20on%20a%20small%20stage%2C%20cinematic%20editorial%20photography%2C%20warm%20neutral%20beige%20background%2C%20soft%20light%2C%20high%20detail%2C%20no%20readable%20text&width=800&height=520&seq=kanliao-cover-02&orientation=landscape",
    duration: "05:12",
    quality: "1080P",
    views: "192.3万",
    likes: "3.1万",
    hot: 9210,
    author: "观剧小组",
    date: "2026-09-09",
    summary:
      "开播当晚讨论量破百万，主创在采访中聊到拍摄节奏与角色塑造，回应了几个被反复讨论的细节。",
    tags: ["新剧", "开播", "主创采访"],
    body: [
      "这部剧开播首日就冲上了讨论榜前列，观众的讨论集中在两个方向：一是开场的叙事节奏，二是主要角色的动机铺垫。",
      "主创团队在随后的采访里回应说，前两集刻意放慢了节奏，是希望观众先熟悉人物关系，把悬念留在第三集之后逐步释放，而不是一上来就把信息全部塞满。",
      "关于造型与光影的争议，摄影指导提到，剧组大量使用了自然光加反光板的方式，为的是让室内戏看起来更接近真实生活的亮度，而不是传统电视剧那种均匀打光。",
      "目前该剧的更新节奏是每周三、周四各两集，追剧的朋友可以先把前四集看完，再对照后面的发展回看细节，会有不少新的发现。",
    ],
    featured: true,
  },
  {
    id: "c-03",
    title: "早市里的手艺人：一把剪刀守了三十年",
    category: "society",
    categoryName: "社会万象",
    cover:
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20craftsman%20hands%20working%20with%20old%20scissors%20at%20a%20sunny%20morning%20market%20stall%2C%20documentary%20editorial%20photography%2C%20warm%20beige%20background%2C%20soft%20natural%20light%2C%20high%20detail%2C%20no%20text&width=800&height=520&seq=kanliao-cover-03&orientation=landscape",
    duration: "06:40",
    quality: "1080P",
    views: "88.7万",
    likes: "1.6万",
    hot: 7450,
    author: "城市观察",
    date: "2026-09-08",
    summary:
      "清晨六点的早市，一位手艺人的摊位前总是排着队，他说最放不下的不是收入，而是老街坊的那句谢谢。",
    tags: ["手艺人", "早市", "人间烟火"],
    body: [
      "天刚蒙蒙亮，早市的摊位就陆续支了起来。在其中一个小角落，一位手艺人已经摆好工具，三十年来，他几乎每天都在同一个位置开始一天的活计。",
      "他手上的那把剪刀用了很多年，刃口被反复打磨，已经比原来窄了一圈。他说工具是死的，习惯是活的，用熟了就是最合手的。",
      "排队的多数是附近的老街坊，有人从小就在这里，如今带着自己的孩子来。手艺人不紧不慢地做着，偶尔抬头聊两句家常，节奏里全是这座城市的清晨。",
      "内容拍得很安静，没有背景音乐的堆砌，环境声里能听到市场里的人来人往，看下来会让人想起小时候跟着大人赶早市的日子。",
    ],
  },
  {
    id: "c-04",
    title: "国产折叠屏新机上手实测：铰链与续航表现亮眼",
    category: "tech",
    categoryName: "科技前沿",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20foldable%20smartphone%20resting%20on%20a%20warm%20minimalist%20desk%20surface%2C%20product%20editorial%20photography%2C%20clean%20warm%20beige%20background%2C%20soft%20studio%20light%2C%20subtle%20reflections%2C%20high%20detail%2C%20no%20text&width=800&height=520&seq=kanliao-cover-04&orientation=landscape",
    duration: "08:05",
    quality: "4K",
    views: "134.2万",
    likes: "2.4万",
    hot: 8830,
    author: "数码轻评",
    date: "2026-09-07",
    summary:
      "连续折合五万次之后铰链依然顺滑，重度使用一天后剩余电量还有三成，这代产品的完成度比预期高。",
    tags: ["折叠屏", "上手实测", "续航"],
    body: [
      "拿到这台折叠屏的第一感受是重量控制得比上一代好，单手拿起来不会明显发沉，展开之后的折痕在实际使用中几乎不打扰阅读。",
      "铰链的阻尼调校是这次的重点。我们在实验室环境里做了连续折合测试，累计五万次之后开合手感依旧均匀，没有出现松垮或异响。",
      "续航部分，我们在同亮度、同网络条件下跑了一整天的高频使用，包括长视频、导航与相机，晚上回到住处仍有三成左右电量，比预期耐用了不少。",
      "当然它也不是没有取舍，外屏的刷新率策略偏保守，日常滑动偶尔能感觉到调整。不过综合下来，这代产品的完成度确实值得单开一期来聊聊。",
    ],
  },
  {
    id: "c-05",
    title: "把阳台改成小花园，她的四季都有花开",
    category: "life",
    categoryName: "生活趣闻",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20small%20balcony%20transformed%20into%20a%20lush%20flower%20garden%20with%20potted%20plants%20in%20warm%20afternoon%20light%2C%20lifestyle%20editorial%20photography%2C%20warm%20neutral%20background%2C%20soft%20shadows%2C%20high%20detail%2C%20no%20text&width=800&height=520&seq=kanliao-cover-05&orientation=landscape",
    duration: "04:36",
    quality: "1080P",
    views: "76.4万",
    likes: "1.9万",
    hot: 6980,
    author: "慢生活手记",
    date: "2026-09-06",
    summary:
      "三平方米的阳台被她种满了四季：春天看花，夏天闻香，秋天收种子，冬天晒太阳，日子被安排得刚刚好。",
    tags: ["阳台花园", "慢生活", "家居"],
    body: [
      "她的阳台只有三平方米，却塞下了二十多种植物。层次是靠高低错落的花架做出来的，最上层是爬藤，中间是开花植物，最底下留给耐阴的绿植。",
      "她分享了一个小原则：先想清楚这个位置能晒到几个小时的太阳，再决定种什么。光照不够的角落硬种喜阳植物，怎么浇水都救不回来。",
      "浇水她用的是接好的雨水，浇之前会先放一会儿，让水温接近室温。她说养花最忌讳的就是忽冷忽热，植物和人一样，喜欢稳定的环境。",
      "视频最后她给了新手一个建议：先从一两种好养的植物开始，养活之后再慢慢加，与其一次买一堆，不如把每一盆都照顾到位。",
    ],
  },
  {
    id: "c-06",
    title: "五分钟看懂年度悬疑片：结局的细节全在这里",
    category: "talk",
    categoryName: "影视解说",
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20cinematic%20still%20of%20an%20empty%20theatre%20with%20rows%20of%20warm%20seats%20and%20a%20glowing%20screen%2C%20film%20editorial%20photography%2C%20warm%20amber%20and%20charcoal%20tones%2C%20soft%20dramatic%20light%2C%20high%20detail%2C%20no%20text&width=800&height=520&seq=kanliao-cover-06&orientation=landscape",
    duration: "05:00",
    quality: "1080P",
    views: "221.8万",
    likes: "3.7万",
    hot: 9340,
    author: "光影笔记",
    date: "2026-09-05",
    summary:
      "很多人看完结局还是没弄明白时间线，这条解说把三处关键伏笔按顺序串了起来，看完豁然开朗。",
    tags: ["悬疑片", "结局解析", "解说"],
    body: [
      "这部电影最容易被忽略的，是开场三分钟里一闪而过的墙面照片。它其实已经把时间线交代清楚了，只是第一次看的人很难注意到。",
      "片中出现了三次同样的雨声，每一次对应的角色状态都不一样。声音在这里承担了剪辑点的作用，把看似跳跃的段落悄悄连成了一条线。",
      "最后一个镜头里的镜子，是整部电影的题眼。导演用反射而不是直接拍摄的方式呈现主角，暗示观众看到的一直是他想让人看到的那一面。",
      "如果你还没看，建议先看完原片再来对照这条解说，避免被剧透影响第一次观看的体验；看过之后再回看细节，会发现很多当初错过的地方。",
    ],
    featured: true,
  },
  {
    id: "c-07",
    title: "暴雨中的逆行者：骑手护送老人蹚过积水路段",
    category: "hot",
    categoryName: "热点突发",
    cover:
      "https://readdy.ai/api/search-image?query=A%20rider%20in%20a%20yellow%20raincoat%20helping%20an%20elderly%20person%20across%20a%20flooded%20city%20street%20after%20heavy%20rain%2C%20documentary%20editorial%20photography%2C%20warm%20overcast%20light%2C%20high%20detail%2C%20no%20text&width=800&height=520&seq=kanliao-cover-07&orientation=landscape",
    duration: "02:18",
    quality: "1080P",
    views: "163.9万",
    likes: "5.4万",
    hot: 9570,
    author: "热料现场",
    date: "2026-09-09",
    summary:
      "积水没过脚踝，他把车停在路边，扶着老人一步一步走过路口，全程被路人拍了下来。",
    tags: ["暴雨", "正能量", "城市温度"],
    body: [
      "那天下午的雨来得又急又猛，几处低洼路口的积水很快就没过了脚踝。一位老人站在路边迟迟不敢迈步，路过的骑手把车停稳后走了过去。",
      "画面里他先是试探了一下水深，确认下面没有松动的井盖，才扶着老人慢慢往前走。整个过程中他一直走在靠车道的一侧，把老人护在里面。",
      "送到对面之后，他简单说了两句就骑车离开了，连名字都没留下。拍下这段画面的路人说，当时雨太大，他甚至没来得及问一句谢谢。",
      "这样的小事在这座城市里每天都在发生，只是很少被记录下来。内容不长，但看完之后心里是暖的。",
    ],
  },
  {
    id: "c-08",
    title: "音乐节收官夜现场：全场合唱的画面太治愈",
    category: "ent",
    categoryName: "娱乐圈",
    cover:
      "https://readdy.ai/api/search-image?query=Crowd%20at%20an%20outdoor%20evening%20music%20festival%20with%20warm%20stage%20lights%20and%20raised%20hands%2C%20concert%20editorial%20photography%2C%20warm%20amber%20glow%2C%20soft%20bokeh%2C%20high%20detail%2C%20no%20readable%20text&width=800&height=520&seq=kanliao-cover-08&orientation=landscape",
    duration: "04:52",
    quality: "4K",
    views: "98.6万",
    likes: "2.8万",
    hot: 8120,
    author: "现场记录仪",
    date: "2026-09-04",
    summary:
      "最后一首歌响起时，台下的手电筒连成一片，几万人同时开口，现场的声音比音响还要大。",
    tags: ["音乐节", "现场", "合唱"],
    body: [
      "收官夜的气氛从傍晚就开始升温，等到压轴歌手走上台时，台下的手电筒已经连成了一条光带，远远看去像一片缓缓起伏的星河。",
      "最后一首是那首传唱度很高的老歌，前奏刚起，台下就有人开始跟唱。到副歌部分，几万人的声音几乎盖过了舞台音响，歌手干脆把话筒转向了观众。",
      "这段画面是观众席中段的位置拍摄的，视角很贴近真实观感，能听清左右的合唱层次，也能看到前排举着灯牌的人是怎样一点点把气氛推上去的。",
      "如果你也去过现场，应该懂那种嗓子喊哑也不想停下来的感觉；如果没去过，这段内容大概是隔着屏幕也能感受到的一次。",
    ],
  },
  {
    id: "c-09",
    title: "AI 修图实测：一键还原老照片里的细节",
    category: "tech",
    categoryName: "科技前沿",
    cover:
      "https://readdy.ai/api/search-image?query=Split%20composition%20of%20an%20old%20faded%20photograph%20being%20restored%20into%20a%20crisp%20warm%20portrait%20frame%20on%20a%20desk%2C%20technology%20editorial%20photography%2C%20warm%20beige%20background%2C%20soft%20light%2C%20high%20detail%2C%20no%20text&width=800&height=520&seq=kanliao-cover-09&orientation=landscape",
    duration: "07:21",
    quality: "1080P",
    views: "112.4万",
    likes: "2.2万",
    hot: 8640,
    author: "数码轻评",
    date: "2026-09-03",
    summary:
      "泛黄的老照片经过修复之后，人物的眼神和衣料纹理都被找了回来，但也要提醒一句：适度使用，别修得不像本人。",
    tags: ["AI修图", "老照片", "实测"],
    body: [
      "这次实测用的是一张保存了四十多年的老照片，边缘有折痕，画面整体泛黄，人物面部已经看不清细节，属于典型的难修复样本。",
      "处理过程分两步，先做底层的去噪与偏色纠正，再进行细节重建。前者决定了整体观感，后者决定了人物的五官是否自然，顺序颠倒往往会出现塑料感。",
      "修复后的结果比预期自然，衣料的褶皱和背景的层次都被找了回来，人物的眼神也有了明确的方向。不过手部区域出现了轻微的重复纹理，需要手动再补一下。",
      "这里也提醒一句：修复的目的是还原，而不是重塑。人物的骨相和特征不要动，参数拉得太满反而会失真，适度才是最好看的状态。",
    ],
  },
  {
    id: "c-10",
    title: "凌晨四点的早餐摊，藏着一座城市的烟火气",
    category: "life",
    categoryName: "生活趣闻",
    cover:
      "https://readdy.ai/api/search-image?query=Steaming%20breakfast%20stall%20before%20dawn%20with%20warm%20lantern%20light%20and%20fresh%20buns%20on%20the%20counter%2C%20documentary%20editorial%20photography%2C%20warm%20amber%20tones%2C%20soft%20haze%2C%20high%20detail%2C%20no%20text&width=800&height=520&seq=kanliao-cover-10&orientation=landscape",
    duration: "05:48",
    quality: "1080P",
    views: "69.3万",
    likes: "1.5万",
    hot: 6720,
    author: "慢生活手记",
    date: "2026-09-02",
    summary:
      "当大多数人还在睡觉的时候，这口蒸笼已经冒着热气，一笼包子、一碗豆浆，撑起了很多人的一整个早晨。",
    tags: ["早餐摊", "烟火气", "城市"],
    body: [
      "凌晨四点，街面还很安静，只有这口蒸笼先醒了过来。老板把前一晚发好的面团搬出来，手法熟练地分成一个个小剂子，动作之间几乎没有停顿。",
      "他说做早餐的秘诀其实很简单，就是「不偷工」。面要醒够时间，肉馅要当天调，豆浆要现磨，这些东西省不得，省了客人一吃就知道。",
      "天快亮的时候，第一批客人陆续来了，有赶早班的，有刚下夜班的，也有专程骑车过来的。大家低头吃着自己的那一份，偶尔聊上两句，然后各自散去。",
      "这条内容没有背景音乐，全靠环境声撑起来。蒸笼的咕嘟声、碗筷的轻响、路口的车流，混在一起，就是这座城市最真实的清晨。",
    ],
  },
  {
    id: "c-11",
    title: "乡村小学运动会的笑脸，被镜头一张张记了下来",
    category: "society",
    categoryName: "社会万象",
    cover:
      "https://readdy.ai/api/search-image?query=Children%20running%20happily%20on%20a%20rural%20school%20playground%20during%20a%20sunny%20sports%20day%2C%20documentary%20editorial%20photography%2C%20warm%20golden%20light%2C%20green%20field%2C%20high%20detail%2C%20no%20text&width=800&height=520&seq=kanliao-cover-11&orientation=landscape",
    duration: "06:12",
    quality: "1080P",
    views: "54.8万",
    likes: "1.3万",
    hot: 6410,
    author: "城市观察",
    date: "2026-09-01",
    summary:
      "没有专业跑道，也没有电子计时，但孩子们冲过终点时的表情，比任何奖牌都真实。",
    tags: ["乡村小学", "运动会", "笑脸"],
    body: [
      "这所乡村小学的操场是草地的，跑道是老师们用石灰粉画出来的，发令用的是一面小旗子。条件不算好，但流程一样不少，检录、热身、接力，一样一样来。",
      "最热闹的是拔河，全校的孩子几乎都围了上来，喊着号子给自己班的队伍加油，嗓子喊哑了也不肯停，连站在旁边的老师都跟着笑出了声。",
      "镜头的节奏很慢，给了每个孩子足够的时间。有人在起跑线上紧张地攥拳，有人冲过终点后回头张望，也有人输了比赛偷偷抹了一下眼睛。",
      "运动会结束时，孩子们排着队把借来的跳绳还了回去。这一幕比成绩单更让人记住，因为那些笑脸，是真的藏不住。",
    ],
  },
  {
    id: "c-12",
    title: "经典科幻片重映：二十年后再看依然震撼",
    category: "talk",
    categoryName: "影视解说",
    cover:
      "https://readdy.ai/api/search-image?query=Retro%20futuristic%20cinematic%20scene%20with%20glowing%20warm%20neon%20signs%20reflected%20on%20wet%20pavement%20at%20night%2C%20film%20editorial%20photography%2C%20warm%20amber%20and%20charcoal%20tones%2C%20soft%20haze%2C%20high%20detail%2C%20no%20text&width=800&height=520&seq=kanliao-cover-12&orientation=landscape",
    duration: "09:30",
    quality: "4K",
    views: "87.1万",
    likes: "1.8万",
    hot: 7260,
    author: "光影笔记",
    date: "2026-08-30",
    summary:
      "当年的特效放到今天依然不显过时，而它真正超前的地方，是对技术与人之间关系的判断。",
    tags: ["科幻片", "重映", "逐帧解析"],
    body: [
      "这次重映用的是修复版母带，画面在保留胶片质感的前提下提升了暗部细节。很多当年看不清的角落，这一次终于能看清里面的布景和道具。",
      "特效部分是最让人意外的，它没有依赖堆砌镜头，而是用克制的长镜头去营造压迫感。二十年过去，这种拍法反而显得比很多新片更成熟。",
      "更值得聊的是它的内核。影片讨论的其实不是技术本身，而是人在面对不可控的力量时，会做出怎样的选择。这一点放在今天看，依旧成立。",
      "如果你当年是在电视上断断续续看完的，这次建议进影院完整看一遍，大银幕对声音和构图的表现，是任何小屏幕都替代不了的。",
    ],
  },
];